import {Input, Layout, Text} from '@ui-kitten/components';
import React from 'react';
import {Image, StyleSheet, View, TouchableOpacity} from 'react-native';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {starBanner} from '../../../assets/images';
import {UN_AUTHENTICATED_ROUTES} from '../../../navigation/constants';
import {forgotPassword} from '../../../redux/actions';
import {isWebDesktopView, px, wp} from '../../../utils';
import AppButton from '../../common/AppButton';

const isWebDesktop = isWebDesktopView();
class ForgotPasswordScreen extends React.Component {
  state = {
    email: '',
    loading: false,
    message: '',
  };

  onChange = (key, value) => {
    this.setState({[key]: value});
  };

  onSubmitError = (msg) => {
    this.onChange('loading', false);
    if (msg) {
      this.onChange('message', msg?.message);
    }
  };

  onSubmitSuccess = (msg) => {
    this.onChange('loading', false);
    if (msg) {
      this.onChange('message', msg?.message);
    }
  };

  submit = () => {
    this.onChange('message', '');
    const {email} = this.state;
    if (email !== '') {
      this.onChange('loading', true);
      this.props.forgotPassword(
        email,
        this.onSubmitSuccess,
        this.onSubmitError,
      );
    } else {
      this.onChange('message', 'Please enter valid email id!');
    }
  };

  onLogin = () => {
    this.props.navigation.push(UN_AUTHENTICATED_ROUTES.signIn.path);
  };

  render() {
    const {email, message, loading} = this.state;

    return (
      <Layout style={styles.container}>
        {isWebDesktop && (
          <Image
            source={starBanner}
            resizeMode="contain"
            style={styles.starImage}
          />
        )}
        <Text
          style={[
            styles.pageTitle,
            isWebDesktop ? styles.textCenter : undefined,
          ]}>
          {'Forgot Password'}
        </Text>
        <Layout style={styles.formContainer}>
          <View>
            <Input
              keyboardType="email-address"
              style={styles.inputBox}
              size={'large'}
              label={'Email address'}
              value={email}
              autoCompleteType="email"
              type="email"
              onChangeText={(text) => this.onChange('email', text)}
            />
            <Text status="danger">{message}</Text>
          </View>
          <View>
            <AppButton
              title="Send Password"
              status="primary"
              size="large"
              appearance="filled"
              onPress={this.submit}
              loader={true}
              loading={loading}
              style={styles.btn}
            />
            <Layout style={styles.signUpContainer}>
              <Text status="basic">{'Your problem solved? back to '}</Text>
              <TouchableOpacity onPress={this.onLogin}>
                <Text style={styles.signUpText} status="primary">
                  {'Login'}
                </Text>
              </TouchableOpacity>
            </Layout>
          </View>
        </Layout>
      </Layout>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: '#FFF',
    flex: 1,
    justifyContent: 'space-between',
    paddingBottom: 24,
    paddingHorizontal: 16,
    alignItems: 'center',
  },
  pageTitle: {
    marginTop: 48,
    fontWeight: '700',
    fontSize: 24,
    width: 328,
  },
  textCenter: {textAlign: 'center'},
  inputBox: {
    marginBottom: 10,
  },
  btn: {
    marginTop: 66,
  },
  signUpContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    marginTop: px(16),
  },
  formContainer: {
    flexGrow: 1,
    marginTop: px(46),
    justifyContent: isWebDesktop ? 'flex-start' : 'space-between',
    width: 328,
  },
  signUpText: {
    textDecorationLine: 'underline',
  },
  text: {
    fontSize: px(18),
    color: '#333',
  },
  image: {
    width: '100%',
    height: px(200),
  },
  starImage: {
    width: wp(15),
    height: wp(15),
  },
});

const mapStateToProps = (state) => ({
  grades: state.general.grades,
});

const mapDispatchToProps = (dispatch) => ({
  forgotPassword: bindActionCreators(forgotPassword, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ForgotPasswordScreen);
